// Pagination.jsx
import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import '../assets/sass/pagination.css';

const Pagination = ({ currentPage, totalPages, goToPage, rowsPerPage, changeRowsPerPage }) => {
    return (
        <div className="pagination_div">
            <select value={rowsPerPage} onChange={(e) => changeRowsPerPage(Number(e.target.value))} className="form-select" aria-label="Default select example" style={{width: "70px"}}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
            </select>

            <span className="page_count">
                Page {currentPage} of {totalPages}
            </span>
            <div className="arrow_btn" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                <MdKeyboardArrowLeft style={{ fontSize: "22px" }} />
            </div>

            <div className="arrow_btn"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                <MdKeyboardArrowRight style={{ fontSize: "22px" }} />
            </div>
        </div>
    );
};

export default Pagination;
